export default "__VITE_ASSET__DbQqLvNx__"